import type { TOC } from '@ember/component/template-only';

export interface UiWellItemSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default <template>
  <div class="ui__well__item" ...attributes>
    {{yield}}
  </div>
</template> satisfies TOC<UiWellItemSignature>;
